<div class="repricing-bulk-setting-modal position-relative">
  <button
    type="button"
    class="close position-absolute"
    style="top: 15px; right: 20px; z-index: 10;"
    aria-label="Close"
    (click)="onDismiss()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
  <div class="container">
    <div class="action-bar">
      <h3>ASC Repricing - Bulk Update</h3>
      <div>
        <div class="d-flex align-items-center">
          <div class="switch switch-primary switch-lg d-inline mx-auto position-relative">
            <input
              type="checkbox"
              id="shownUnchangedToggle"
              [checked]="isShownRecommendationChanged"
              [disabled]="isLoading"
              (change)="toggleShownUnchanged()"
            />
            <label
              for="shownUnchangedToggle"
              class="cr"
            >
            <div
              *ngIf="isLoading"
              class="position-absolute"
              [style.left]="isShownRecommendationChanged ? '25%' : '75%'"
              style="top: 50%; transform: translate(-50%, -50%); pointer-events: none;"
            >
              <span
                class="spinner-border spinner-border-sm"
                [style.color]="isShownRecommendationChanged ? '#fff' : '#000'"
              ></span>
            </div>
          </label>
          </div>
          <label for="shownUnchangedToggle" class="ml-2 mt-auto mb-1">
            Show changed only
          </label>
        </div>
      </div>
    </div>
<!-- 
    <div *ngIf="missingPriceCount > 0" class="alert alert-warning d-flex align-items-center mb-3" role="alert">
      <i class="fas fa-exclamation-triangle mr-2"></i>
      <span>
        <strong>{{ missingPriceCount }} item{{ missingPriceCount > 1 ? 's have' : ' has' }} no price set</strong>
        and cannot be synced until a price is entered.
      </span>
    </div> -->

    <kendo-grid
      class="repricing-bulk-setting-table"
      [data]="shownGridData"
      [kendoGridSelectBy]="'id'"
      [selectedKeys]="gridSelectedKeys"
      [selectable]="selectableSettings"
      [height]="600"
      [loading]="isLoading"
      [rowClass]="rowClass"
      [kendoGridExpandDetailsBy]="expandDetailsBy"
      [(expandedDetailKeys)]="expandedDetailKeys"
      [pageable]="true"
      [pageSize]="pageSize"
      [skip]="skip"
      (pageChange)="pageChange($event)"
      (selectionChange)="onSelectionChange($event)"
    >
      <kendo-grid-checkbox-column
        [width]="50"
        [headerClass]="'col-header-sku'"
      >
        <ng-template kendoGridHeaderTemplate>
          <input
            type="checkbox"
            kendoCheckBox
            id="selectAllCheckboxId"
            kendoGridSelectAllCheckbox
            [state]="selectAllState"
            (selectAllChange)="onSelectAllChange($event)"
          />
          <label class="k-checkbox-label" for="selectAllCheckboxId"></label>
        </ng-template>
      </kendo-grid-checkbox-column>

      <kendo-grid-column
        title="SKU / ASIN"
        [width]="220"
        [headerClass]="'col-header-sku text-center'"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="sku-cell-content">
            <a [href]="dataItem.skuLink" target="_blank" class="sku-link">{{
              dataItem.sku
            }}</a>
            <span class="asin-tag">{{ dataItem.asin }}</span>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        title="Amazon Seller Central (Current)"
        [width]="330"
        [headerClass]="'col-header-amazon text-center'"
        class="cell-amazon"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="dataItem.isSaleActive">
            <div class="label label-medium text-current-label">
              Sale Price
            </div>

            <div class="price-row">
              <span class="price-xl text-dark">{{
                dataItem.currentSalePrice
                  | currency
                    : displayCurrency?.code
                    : displayCurrency?.symbol
                    : "1.2"
              }}</span>

              <app-discount-tag
                [originalText]="'Your Price'"
                [originalPrice]="dataItem?.currentInboundPrice"
                [salePrice]="dataItem?.currentSalePrice"
                [hardSavePercent]="dataItem?.saleSavePercent"
                [displayCurrency]="displayCurrency"
                [closestParentClass]="'repricing-bulk-setting-table'"
              ></app-discount-tag>
            </div>
          </ng-container>

          <div [ngClass]="{'mt-3': dataItem.isSaleActive}">
            <div class="label label-medium">Your Price</div>

            <div class="price-row">
              <span class="price-xl text-dark">{{
                dataItem.currentInboundPrice
                  | currency
                    : displayCurrency?.code
                    : displayCurrency?.symbol
                    : "1.2"
              }}</span>
            </div>
          </div>

          <div class="mt-3">
            <div class="info-label">Min Price - Max Price</div>
            <div class="info-val">
              {{
                dataItem.currentMin
                  | currency
                    : displayCurrency?.code
                    : displayCurrency?.symbol
                    : "1.2"
              }}
              -
              {{
                dataItem.currentMax
                  | currency
                    : displayCurrency?.code
                    : displayCurrency?.symbol
                    : "1.2"
              }}
            </div>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        title="Inventory Optimizer (Proposed)"
        [headerClass]="'col-header-optimizer text-center'"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <!-- isSaleActive: Sale Price (read-only + trend + discount tag) → Your Price (inline-edit) -->
          <ng-container *ngIf="dataItem.isSaleActive">
            <!-- Sale Price — read-only, derived from Your Price -->
            <div>
              <div
                class="label label-medium"
                [ngClass]="{
                  'label-trend-inc': editState[dataItem.id]?.effectiveTrend > 0,
                  'label-trend-dec': editState[dataItem.id]?.effectiveTrend < 0,
                  'text-current-label': editState[dataItem.id]?.effectiveTrend === 0
                }"
              >Sale Price</div>
              <div class="price-row">
                <span
                  class="price-xl"
                  [ngClass]="{
                    'text-new-inc': editState[dataItem.id]?.effectiveTrend > 0,
                    'text-new-dec': editState[dataItem.id]?.effectiveTrend < 0
                  }"
                >
                  {{
                    editState[dataItem.id]?.derivedSalePrice
                      | currency
                        : displayCurrency?.code
                        : displayCurrency?.symbol
                        : "1.2"
                  }}
                </span>
                <app-discount-tag
                  [originalText]="'Your Price'"
                  [originalPrice]="editState[dataItem.id]?.customPrice"
                  [salePrice]="editState[dataItem.id]?.derivedSalePrice"
                  [displayCurrency]="displayCurrency"
                  [hardSavePercent]="dataItem?.saleSavePercent"
                  [closestParentClass]="'repricing-bulk-setting-table'"
                ></app-discount-tag>
              </div>
            </div>

            <!-- Your Price — editable via price-editor, no discount tag -->
            <div class="mt-3">
              <app-repricing-price-editor
                label="Your Price"
                [displayCurrency]="displayCurrency"
                [customPrice]="editState[dataItem.id]?.customPrice"
                [targetPrice]="dataItem.newInboundPrice"
                [trendPercentage]="dataItem.trendPercentage"
                [effectiveTrend]="editState[dataItem.id]?.effectiveTrend"
                [validationError]="editState[dataItem.id]?.validationError"
                [isEditing]="editState[dataItem.id]?.isEditing"
                [isMissingPrice]="dataItem.state === ItemPriceState.MISSING_PRICE"
                (customPriceChange)="onPriceChange($event, dataItem)"
                (resetPrice)="resetOverride(dataItem)"
                (editToggled)="openOverride(dataItem)"
                (priceCommitted)="commitOverride(dataItem)">
              </app-repricing-price-editor>
            </div>
          </ng-container>

          <!-- No sale: Calculated (read-only) → Your Price (inline-edit) -->
          <ng-container *ngIf="!dataItem.isSaleActive">
            <div class="d-flex gap-3 align-items-start">
              <ng-container *ngIf="dataItem.calculatedInboundPrice !== dataItem.newInboundPrice">
                <div>
                  <span class="label label-medium text-calculated-label">Calculated</span>
                  <div class="price-row flex-nowrap">
                    <span
                      class="price-xl price-strike"
                      [ngClass]="{
                        'text-emerald': dataItem.trendPercentage > 0,
                        'text-rose': dataItem.trendPercentage < 0
                      }"
                    >
                      {{
                        dataItem.calculatedInboundPrice
                          | currency
                            : displayCurrency?.code
                            : displayCurrency?.symbol
                            : "1.2"
                      }}
                    </span>
                    <app-repricing-trend-badge
                      [trendPercentage]="dataItem.trendPercentage"
                      [isMuted]="false">
                    </app-repricing-trend-badge>
                  </div>
                </div>
                <div class="arrow-changes">&rarr;</div>
              </ng-container>

              <app-repricing-price-editor
                [displayCurrency]="displayCurrency"
                [customPrice]="editState[dataItem.id]?.customPrice"
                [targetPrice]="dataItem.newInboundPrice"
                [trendPercentage]="dataItem.trendPercentage"
                [effectiveTrend]="editState[dataItem.id]?.effectiveTrend"
                [validationError]="editState[dataItem.id]?.validationError"
                [isEditing]="editState[dataItem.id]?.isEditing"
                [isExceedRange]="dataItem.calculatedInboundPrice !== dataItem.newInboundPrice"
                [isMissingPrice]="dataItem.state === ItemPriceState.MISSING_PRICE"
                (customPriceChange)="onPriceChange($event, dataItem)"
                (resetPrice)="resetOverride(dataItem)"
                (editToggled)="openOverride(dataItem)"
                (priceCommitted)="commitOverride(dataItem)">
              </app-repricing-price-editor>
            </div>
          </ng-container>
          <div class="mt-3">
            <div class="min-max-row">
              <div class="min-max-section">
                <!-- 
                  Handle both CSV Upload version and Normal Update version:
                  1. isCustomMinTouched: User edited the value manually in this session
                  2. customMin != null: Value uploaded via CSV (from backend response)
                  3. currentMin: Fallback to current default value for normal updates
                -->
                <app-repricing-price-editor
                  label="Min Price"
                  labelClass="label-xs gray"
                  [displayCurrency]="displayCurrency"
                  [showTrendBadge]="false"
                  [showSuggestedPrice]="true"
                  [nullPlaceholder]="'N/A'"
                  [customPrice]="editState[dataItem.id]?.isCustomMinTouched 
                  ? editState[dataItem.id].customMin 
                  : (editState[dataItem.id].customMin != null 
                      ? editState[dataItem.id].customMin 
                      : dataItem.currentMin)"
                  [targetPrice]="dataItem.suggestedMin != null ? dataItem.suggestedMin : dataItem.currentMin"
                  [validationError]="editState[dataItem.id]?.minValidationError"
                  [isEditing]="editState[dataItem.id]?.isEditingMin"
                  (customPriceChange)="onMinChange($event, dataItem.id, dataItem)"
                  (resetPrice)="resetCustomMin(dataItem.id, dataItem)"
                  (editToggled)="openEditMin(dataItem.id)"
                  (priceCommitted)="commitEditMin(dataItem.id)">
                </app-repricing-price-editor>
              </div>
              <span class="min-max-separator">—</span>
              <div class="min-max-section">
                <!-- 
                  Handle both CSV Upload version and Normal Update version:
                  1. isCustomMaxTouched: User edited the value manually in this session
                  2. customMax != null: Value uploaded via CSV (from backend response)
                  3. currentMax: Fallback to current default value for normal updates
                -->
                <app-repricing-price-editor
                  label="Max Price"
                  labelClass="label-xs gray"
                  [displayCurrency]="displayCurrency"
                  [showTrendBadge]="false"
                  [showSuggestedPrice]="true"
                  [nullPlaceholder]="'N/A'"
                  [customPrice]="editState[dataItem.id]?.isCustomMaxTouched 
                  ? editState[dataItem.id].customMax 
                  : (editState[dataItem.id].customMax != null 
                    ? editState[dataItem.id].customMax  
                    : dataItem.currentMax)"
                  [targetPrice]="dataItem.suggestedMax != null ? dataItem.suggestedMax : dataItem.currentMax"
                  [validationError]="editState[dataItem.id]?.maxValidationError"
                  [isEditing]="editState[dataItem.id]?.isEditingMax"
                  (customPriceChange)="onMaxChange($event, dataItem.id, dataItem)"
                  (resetPrice)="resetCustomMax(dataItem.id, dataItem)"
                  (editToggled)="openEditMax(dataItem.id)"
                  (priceCommitted)="commitEditMax(dataItem.id)">
                </app-repricing-price-editor>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-grid-column>

      <ng-template kendoGridNoRecordsTemplate>
        <div class="h-full py-4">
          There are no recommendation(s) to show. <br />
          Please begin by reviewing the instructions above.
        </div>
      </ng-template>

      <ng-template kendoGridDetailTemplate let-dataItem>
        <app-repricing-recommend-analysis-content
          [isFitGrid]="true"
          [repricingItem]="dataItem"
        ></app-repricing-recommend-analysis-content>
      </ng-template>

      <ng-template
        kendoPagerTemplate
        let-totalPages="totalPages"
        let-currentPage="currentPage"
      >
        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
        <kendo-pager-numeric-buttons
          [buttonCount]="5"
        ></kendo-pager-numeric-buttons>
        <div class="k-pager-info k-label">
          {{ (currentPage - 1) * pageSize + 1 }} -
          {{ (currentPage - 1) * pageSize + pageSize }}
          of
          {{ totalCount | number }} items
        </div>
        <kendo-pager-next-buttons></kendo-pager-next-buttons>
      </ng-template>
    </kendo-grid>
  </div>

  <div class="footer">
    <div class="note">
      <strong>Notes:</strong>
      <ul class="notes-list">
        <li>
          <span class="asterisk">(*)</span> Once the
          <strong>New Price</strong> is out of range (Min Price - Max Price),
          the <strong>New Price</strong> will add/subtract
          <strong>$1</strong> and update Min/Max Price correspondingly.
        </li>
        <li>
          Changes will <strong>take 15 minutes to reflect</strong> on Amazon
          Seller Central.
        </li>
      </ul>
    </div>

    <div class="actions">
      <button class="btn cancel" (click)="onDismiss()">
        Cancel
      </button>
      <button
        type="button"
        class="btn save"
        [disabled]="isLoading || isSubmitting || gridSelectedKeys.length === 0 || hasAnyValidationError || hasSelectedMissingPriceWithoutEntry"
        [ngStyle]="{
          cursor:
            !isLoading && !isSubmitting && gridSelectedKeys.length > 0
              ? 'pointer'
              : 'not-allowed'
        }"
        (click)="onSync($event)"
      >
        Sync to Amazon
      </button>
    </div>
  </div>
</div>
